import Radio from "@/components/form/radio/Radio"
import { PlayerDevice } from "@/types/device"
import { useMemo } from "react"

import "./matchablePlayerListItem.scss"

export default function MatchablePlayerListItem(
  props: PlayerDevice & { selected: boolean; onClick: () => void },
) {
  const { nickname, backNumber, deviceModel, deviceNumber, deviceVersion } = props

  const deviceSerial = useMemo(() => {
    if (!deviceModel) {
      return ""
    }

    return `${deviceModel}-${deviceVersion}-${deviceNumber.toString().padStart(5, "0")}`
  }, [props])

  return (
    <div className="MatchablePlayerListItemCont" onClick={props.onClick}>
      <Radio checked={props.selected} />
      <span className="player-info">
        <p className="player-name">
          {backNumber} {nickname}
        </p>
        <p>{deviceSerial}</p>
      </span>
    </div>
  )
}
